import {
  AUTH_TOKEN_KEY,
  BANNER_KEY,
  SIGNUP_EMAIL_KEY,
  STORAGE_PERSIST_KEY,
  USER_TYPE_KEY,
  USER_ID_KEY,
  USER_PLAN_KEY,
  PURCHASE_PLAN_MODAL_KEY,
  MONETIZATION_KEY,
  WELCOME_MODAL_KEY,
  AUTH_RTOKEN_KEY,
  CURRENT_PATH_KEY,
  ASIDE_STATE_KEY,
  TRACKING_ID_KEY,
  SURMOUNT_STATUS_MODAL_SHOWN_KEY,
} from "./constants";
import { getEncrypted, getDencrypted } from "./security";

const getStorage = () => {
  const persist = localStorage.getItem(STORAGE_PERSIST_KEY);
  if (persist === null) {
    localStorage.clear();
  }
  return JSON.parse(persist) === true ? localStorage : sessionStorage;
};

export const getItemFromStorage = (key) => {
  const storage = getStorage();
  const encData = storage.getItem(key);
  if (encData) {
    const decData = getDencrypted(encData);
    return JSON.parse(decData);
  }
  return null;
};

export const setItemInStorage = (key, data) => {
  if (data) {
    const storage = getStorage();
    const stringifyData = JSON.stringify(data);
    const encData = getEncrypted(stringifyData);
    storage.setItem(key, encData);
  }
};

export const removeItemFromStorage = (key) => {
  if (key) {
    const storage = getStorage();
    storage.removeItem(key);
  }
};

export const appClearStorage = () => {
  removeItemFromStorage(USER_ID_KEY);
  removeItemFromStorage(AUTH_TOKEN_KEY);
  removeItemFromStorage(AUTH_RTOKEN_KEY);
  removeItemFromStorage(BANNER_KEY);
  removeItemFromStorage(SIGNUP_EMAIL_KEY);
  removeItemFromStorage(USER_PLAN_KEY);
  removeItemFromStorage(USER_TYPE_KEY);
  removeItemFromStorage(PURCHASE_PLAN_MODAL_KEY);
  removeItemFromStorage(MONETIZATION_KEY);
  removeItemFromStorage(WELCOME_MODAL_KEY);
  removeItemFromStorage(ASIDE_STATE_KEY);
  // Clear sessionStorage flag for Surmount status modal
  sessionStorage.removeItem(SURMOUNT_STATUS_MODAL_SHOWN_KEY);
};

export const appResetPersistStorage = () => {
  localStorage.removeItem(USER_ID_KEY);
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_RTOKEN_KEY);
  localStorage.removeItem(BANNER_KEY);
  localStorage.removeItem(SIGNUP_EMAIL_KEY);
  localStorage.removeItem(USER_PLAN_KEY);
  localStorage.removeItem(USER_TYPE_KEY);
  localStorage.removeItem(PURCHASE_PLAN_MODAL_KEY);
  localStorage.removeItem(MONETIZATION_KEY);
  localStorage.removeItem(WELCOME_MODAL_KEY);
  localStorage.removeItem(CURRENT_PATH_KEY);
  localStorage.removeItem(ASIDE_STATE_KEY);
  localStorage.removeItem(TRACKING_ID_KEY);

  localStorage.setItem(STORAGE_PERSIST_KEY, false);
};

// For async localstorage persistance
export const asyncSetItem = (key, data) => {
  return new Promise((resolve, reject) => {
    try {
      localStorage.setItem(key, data);
      resolve();
    } catch (error) {
      reject(error);
    }
  });
};

export const asyncGetItem = (key) => {
  return new Promise((resolve, reject) => {
    try {
      const data = localStorage.getItem(key);
      resolve(data);
    } catch (error) {
      reject(error);
    }
  });
};

// For localstorage persistance
export const setItemPersist = (key, data) => {
  if (key) {
    const stringifyData = JSON.stringify(data);
    const encData = getEncrypted(stringifyData);
    localStorage.setItem(key, encData);
  }
};

export const getItemPersist = (key) => {
  const encData = localStorage.getItem(key);
  if (encData) {
    const decData = getDencrypted(encData);
    return JSON.parse(decData);
  }
  return null;
};
